const _excluded = ["onClick", "disabled", "saveParams", "dataTestid", "text"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { Button } from '.';
import { useTranslation } from 'react-i18next';
export function SaveButton(_ref) {
  let {
      onClick,
      disabled = false,
      saveParams = [],
      dataTestid = 'save_button',
      text = 'save'
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Button, _extends({
    type: "submit",
    icon: "save",
    loading: false,
    onClick: () => onClick && onClick(...saveParams),
    "data-testid": dataTestid,
    disabled: disabled
  }, props), t(text));
}